var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('LeaveCodeHeader',{attrs:{"pageNum":_vm.pageNum,"rowSize":_vm.rowSize},on:{"load":_vm.load}}),_c('LeaveCodeList',{attrs:{"items":_vm.items}}),_c('PageNavigationBar',{attrs:{"value":_vm.pageNum,"total":_vm.totalCount,"size":_vm.rowSize,"range":5},on:{"pageMove":_vm.pageMove}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }